import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EvaluacionGeneralComponent } from './evalucionGeneral/evaluacionGeneral.component';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material';
import { AppDateAdapter } from 'src/shared/format-datepicker';



@Component({
  selector: 'app-evaluaciones',
  templateUrl: './evaluaciones.component.html',
  styleUrls: ['./evaluaciones.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' }
  ]
})
export class EvaluacionesComponent implements OnInit {
  /**
   * Variable que indica la pagina en la que te encuentras
   */
  p = 1;
  /**
   * Almacenaremos los alumnos
   */
  public alumnos = [];
  /**
   * Lista a mostrar
   */
  public alumnosAula = [];
  /**
   * Almacenaremos todas las planificaciones
   */
  public planificaciones = [];
  public ambitos = [];
  public objetivos = [];
  public nucleo = [];

  public evaluaciones = [];
  public documentId = null;
  public currentStatus = 1;
  public newEvaluacForm = new FormGroup({
    // nivel: new FormControl([], Validators.required),
    alumno: new FormControl([], Validators.required),
    nivel: new FormControl([], Validators.required),
    educadora: new FormControl('', Validators.required),
    ambito: new FormControl('', Validators.required),
    nucleo: new FormControl('', Validators.required),
    objetivo: new FormControl('', Validators.required),
    concepto: new FormControl('', Validators.required),
    fecha: new FormControl('', Validators.required),
    observacionesAlumno: new FormControl(''),
    id: new FormControl('')
  });

  /**
   * Opciones a mostrar en nivel
   */
  opcionesNivel = [
    {
      nombre: 'Kinder'
    },
    {
      nombre: 'Pre Kinder'
    },
    {
      nombre: 'Medio Mayor'
    },
    {
      nombre: 'Medio Menor'
    },
    {
      nombre: 'Sala Cuna Mayor'
    },
    {
      nombre: 'Sala Cuna Menor'
    },
  ];

  opcionesConcepto = [
    {
      nombre: 'L'
    },
    {
      nombre: 'P/L'
    },
    {
      nombre: 'P/L+'
    },
    {
      nombre: 'P/L-'
    },
    {
      nombre: 'A'
    },
    {
      nombre: 'R'
    },
  ];

  /**
   * Variables en los cual guardaremos el filtro actual
   */
  filteredOptions: Observable<any[]>;
  filteredNivel: Observable<any[]>;
  filteredAmbito: Observable<any[]>;
  filteredObjetivo: Observable<any[]>;
  filteredNucleo: Observable<any[]>;
  filteredConcepto: Observable<any[]>;

  constructor(private firestoreService: FirestoreService, public dialog: MatDialog, private dateAdapter: DateAdapter<any>) {
    this.newEvaluacForm.setValue({
      id: '',
      alumno: [],
      nivel: [],
      educadora: '',
      observacionesAlumno: '',
      ambito: '',
      nucleo: '',
      objetivo: '',
      concepto: '',
      fecha: ''
    });
  }

  ngOnInit() {
    this.firestoreService.getAllData('Evaluaciones').subscribe(evaluacionesSnapshot => {
      this.evaluaciones = [];
      evaluacionesSnapshot.forEach((evaluacionesData: any) => {
        this.evaluaciones.push({
          id: evaluacionesData.payload.doc.id,
          data: evaluacionesData.payload.doc.data()
        });
        this.evaluaciones.sort((a, b) => {
          return a.data.alumno.localeCompare(b.data.alumno);
        });
        this.evaluaciones.sort((a, b) => {
          if (a.data.fecha <= b.data.fecha) {
            return 1;
          } else {
            return -1;
          }
        });
      });
    });
    this.getAlumnos();
    this.filtroNivel();
    this.getPlanificacion();
    this.filtroConcepto();
    this.getEducadora();
    this.filtroAmbito();
    this.filtroNucleo();
    this.filtroObjetivo();
    this.filtroConcepto();
    this.dateAdapter.setLocale('es');
    this.newEvaluacForm.controls.educadora.disable();
  }

  checkConcepto() {
    const filtro = this.opcionesConcepto.filter(x => x.nombre === this.newEvaluacForm.controls.concepto.value);
    if (filtro.length < 1) {
      this.newEvaluacForm.controls.concepto.setValue('');
    }
  }

  checkNivel() {
    const filtro = this.opcionesNivel.filter(x => x.nombre === this.newEvaluacForm.controls.nivel.value);
    if (filtro.length < 1) {
      this.newEvaluacForm.controls.nivel.setValue('');
    }
  }

  checkAlumno() {
    const filtro = this.alumnosAula.filter(x => x.nombreCompleto === this.newEvaluacForm.controls.alumno.value);
    if (filtro.length < 1) {
      this.newEvaluacForm.controls.alumno.setValue('');
    }
  }

  checkAmbito() {
    const filtro = this.ambitos.filter(x => x.nombre === this.newEvaluacForm.controls.ambito.value);
    if (filtro.length < 1) {
      this.newEvaluacForm.controls.ambito.setValue('');
    }
  }
  checkNucleo() {
    const filtro = this.nucleo.filter(x => x.nombre === this.newEvaluacForm.controls.nucleo.value);
    if (filtro.length < 1) {
      this.newEvaluacForm.controls.nucleo.setValue('');
    }
  }
  checkObjetivo() {
    const filtro = this.objetivos.filter(x => x.nombre === this.newEvaluacForm.controls.objetivo.value);
    if (filtro.length < 1) {
      this.newEvaluacForm.controls.objetivo.setValue('');
    }
  }

  /**
   * Servicio que permite traer todos los alumnos
   */
  getAlumnos() {
    this.firestoreService.getAlums().subscribe(alumnosSnapshot => {
      this.alumnos = [];
      alumnosSnapshot.forEach((alumnosData: any) => {
        this.alumnos.push(
          alumnosData.payload.doc.data()
        );
      });
      this.alumnos.forEach(alumno => {
        alumno.nombreCompleto =
          alumno.nombre_alum.concat(' ')
            .concat(alumno.ape_pat_alum)
            .concat(' ')
            .concat(alumno.ape_mat_alum);
      });
      this.alumnos.sort((a, b) => {
        return a.nombre_alum.localeCompare(b.nombre_alum);
      });
      // this.filtroAlumnos();
    });
  }

  /**
   * Obtenemos nombre del login
   */
  getEducadora() {
    if (sessionStorage.getItem('usuario')) {
      const user = JSON.parse(sessionStorage.getItem('usuario'));
      const uid = user.i.user.uid;
      let nombre = '';
      this.firestoreService.getUsuari(uid).subscribe((data) => {
        const usuario: any = data.payload.data();
        nombre = usuario.nombre_usuar.concat(' ')
          .concat(usuario.ape_pat_usuar)
          .concat(' ')
          .concat(usuario.ape_mat_usuar);
        this.newEvaluacForm.controls.educadora.setValue(nombre);
      });
    }
  }
  /**
   * obtener todas las planificaciones de firebase
   */
  getPlanificacion() {
    this.firestoreService.getPlanifics().subscribe(planificacionesSnapshot => {
      this.planificaciones = [];
      planificacionesSnapshot.forEach((planificacionesData: any) => {
        this.planificaciones.push({
          id: planificacionesData.payload.doc.id,
          data: planificacionesData.payload.doc.data()
        });
        this.ambitos = [];
        this.objetivos = [];
        this.nucleo = [];
        this.planificaciones.forEach(plan => {
          this.ambitos.push({ nombre: plan.data.ambito });
          this.objetivos.push({ nombre: plan.data.objetivo });
          this.nucleo.push({ nombre: plan.data.nucleo });
        });
        this.filtroAmbito();
        this.filtroObjetivo();
        this.filtroNucleo();
      });
    });
  }
  /**
   * Segun lo que se ingrese en el input de alumno se actualizaran las opciones a mostrar
   */
  filtroAlumnos() {
    this.filteredOptions = this.newEvaluacForm.controls.alumno.valueChanges
      .pipe(
        startWith(''),
        // map(value => typeof value === 'string' ? value : value.nombreCompleto),
        map(name => name ? this._filter(name) : this.alumnosAula.slice())
      );
  }

  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroNivel() {
    this.filteredNivel = this.newEvaluacForm.controls.nivel.valueChanges.pipe(
      startWith(''),
      map(name => name ? this._filterNivel(name) : this.opcionesNivel.slice())
    );
  }

  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroAmbito() {
    this.filteredAmbito = this.newEvaluacForm.controls.ambito.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterAmbito(name) : this.ambitos.slice())
    );
  }

  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroObjetivo() {
    this.filteredObjetivo = this.newEvaluacForm.controls.objetivo.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterObjetivos(name) : this.objetivos.slice())
    );
  }
  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroNucleo() {
    this.filteredNucleo = this.newEvaluacForm.controls.nucleo.valueChanges.pipe(
      startWith(''),
      // map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterNucleo(name) : this.nucleo.slice())
    );
  }

  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroConcepto() {

    this.filteredConcepto = this.newEvaluacForm.controls.concepto.valueChanges.pipe(
      startWith(''),
      map(name => name ? this._filterConcepto(name) : this.opcionesConcepto.slice())
    );
  }

  onSelectionChange(event) {
    this.alumnosAula = [];
    this.alumnos.forEach(alumno => {
      if (alumno.nivel_educ.toLowerCase().trim() === event.option.value.toLowerCase().trim()) {
        this.alumnosAula.push(alumno);
      }
    });
    this.filtroAlumnos();
    this.newEvaluacForm.controls.alumno.setValue('');
  }

  change(event) {
    this.alumnosAula = [];
    this.alumnos.forEach(alumno => {
      if (alumno.nivel_educ.toLowerCase().trim() === event.target.value.toLowerCase().trim()) {
        this.alumnosAula.push(alumno);
      }
    });
    this.filtroAlumnos();
    this.newEvaluacForm.controls.alumno.setValue('');
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.alumnosAula.filter(option => option.nombreCompleto.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterNivel(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesNivel.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterAmbito(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.ambitos.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterObjetivos(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.objetivos.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }
  private _filterNucleo(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.nucleo.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }
  private _filterConcepto(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesConcepto.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  public newevaluaciones(form, documentId = this.documentId) {
    if (this.currentStatus === 1) {
      const data = {
        nivel: form.nivel,
        alumno: form.alumno,
        educadora: this.newEvaluacForm.controls.educadora.value,
        ambito: form.ambito,
        nucleo: form.nucleo,
        objetivo: form.objetivo,
        concepto: form.concepto,
        fecha: form.fecha.getTime(),
        observacionesAlumno: form.observacionesAlumno,
      };
      this.firestoreService.createEvaluac(data).then(
        () => {
          this.newEvaluacForm.reset();
          this.getEducadora();
          this.filtroNivel();
          this.filtroAmbito();
          this.filtroNucleo();
          this.filtroObjetivo();
          this.filtroConcepto();
          Swal.fire(
            'Creado!',
            'El registro se creo correctamente.',
            'success'
          );
        },
        error => {
        }
      );
    } else {
      const data = {
        nivel: form.nivel,
        alumno: form.alumno,
        educadora: this.newEvaluacForm.controls.educadora.value,
        ambito: form.ambito,
        nucleo: form.nucleo,
        objetivo: form.objetivo,
        concepto: form.concepto,
        fecha: form.fecha.getTime(),
        observacionesAlumno: form.observacionesAlumno,
      };
      this.firestoreService.updateEvaluac(documentId, data).then(
        () => {
          this.currentStatus = 1;
          this.newEvaluacForm.reset();
          this.getEducadora();
          this.filtroNivel();
          this.filtroAmbito();
          this.filtroNucleo();
          this.filtroObjetivo();
          this.filtroConcepto();
          Swal.fire(
            'Editado!',
            'El registro se edito correctamente.',
            'success'
          );
        },
        error => {
        }
      );
    }
  }

  limpiar() {
    this.newEvaluacForm.reset();
    this.getEducadora();
    this.filtroNivel();
    this.filtroAmbito();
    this.filtroNucleo();
    this.filtroObjetivo();
    this.filtroConcepto();
  }

  public editEvaluaciones(documentId) {
    const editSubscribe = this.firestoreService.getData('Evaluaciones', documentId).subscribe((evaluaciones) => {
      this.currentStatus = 2;
      this.documentId = documentId;
      this.newEvaluacForm.setValue({
        id: documentId,
        nivel: evaluaciones.payload.data()['nivel'],
        alumno: evaluaciones.payload.data()['alumno'],
        educadora: evaluaciones.payload.data()['educadora'],
        ambito: evaluaciones.payload.data()['ambito'],
        nucleo: evaluaciones.payload.data()['nucleo'],
        objetivo: evaluaciones.payload.data()['objetivo'],
        concepto: evaluaciones.payload.data()['concepto'],
        fecha: new Date(evaluaciones.payload.data()['fecha']),
        observacionesAlumno: evaluaciones.payload.data()['observacionesAlumno']
      });
      editSubscribe.unsubscribe();
    });
  }

  public delPlanific(documentId) {
    Swal.fire({
      title: 'Estas seguro?',
      text: 'No podrás revertir esta accion!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrar!'
    }).then((result) => {
      if (result.value) {
        this.firestoreService.deleteData('Evaluaciones', documentId).then(() => {
          Swal.fire(
            'Borrado!',
            'El registro fue eliminado.',
            'success'
          );
        }, (error) => {
        });
      }
    });
  }

  /**
   * Abrir Modal
   */
  openDialog() {
    const dialogRef = this.dialog.open(EvaluacionGeneralComponent, {
      width: '550px',
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.animal = result;
    });
  }
}
